import { RatioType } from 'video-editor-renderer'
import type { TemplatePreviews } from '@ve-pro/api/project/type'
import { ElUploadInternalFileDetail } from 'element-ui/types/upload'
import { getImageSize } from '@com/image'
import { Message } from 'element-ui'
import { t } from '@/lang'

export type RatioCoverType = {
  cover_previews: TemplatePreviews // path路径
  url: TemplatePreviews // 图片路径
  value: string // 值
  label: string // 名称
  children: RatioType[] // 比例
}

const ratioChildren = [RatioType['9:16'], RatioType['16:9'], RatioType['1:1']]

export const coverOptions: RatioCoverType[] = [
  // 模版视频项目中文"zh-CN",EN为原语言，value为空
  {
    value: 'zh-CN',
    label: '中文',
    children: ratioChildren,
    cover_previews: {},
    url: {},
  },
  {
    value: '',
    label: 'EN',
    children: ratioChildren,
    cover_previews: {},
    url: {},
  },
]

// 上传链接根据url路径获取path
export function extractPathFromUrl(url: string) {
  // eslint-disable-next-line no-useless-escape
  const match = url.match(/(\/\/[^\/]+)?(\/[^?#]*)/)
  if (match) {
    const path = match[2]
    return path && path.startsWith('/') ? path.substr(1) : path
  }
  return null // 没有匹配到路径部分
}

// 校验文件大小
export const validateFileSize = (
  file: ElUploadInternalFileDetail,
  maxSize: number,
): boolean => {
  const imgSize = Number(file.size / 1024 / 1024) > maxSize
  if (imgSize) {
    setTimeout(() => {
      Message.warning(
        `${t('playTurbo.assetLibrary.asset.upload.errorFileSize', {
          size: `${maxSize}M`,
        })}`,
      )
    })
  }
  return !imgSize
}

// 校验比例
export const validateFileRadio = async (
  file: ElUploadInternalFileDetail,
  ratio: RatioType,
) => {
  const firstFrame = await getImageSize(file.raw)
  console.log(ratio, 'ratio')
  console.log(firstFrame, 'firstFrame')
}
